import { render } from "./App.vue?vue&type=template&id=54906ba4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=54906ba4&lang=css"
script.render = render

export default script